export default __webpack_public_path__ + "static/media/webmoney.e3255d17.svg";